import React from 'react';
import './About.css';
import ContactCTA from '../../components/ContactCTA/ContactCTA';

const About = () => {
  return (
    <div className="about-page">
      {/* 主要内容区域 */}
      <div className="about-container">
        <div className="about-content">
          <div className="about-text">
            <h1>关于我</h1>
            <p>我毕业于产品设计专业，拥有建模、平面设计、剪辑与运营的扎实经验，也曾在Bilibili上产出内容，单条视频有10万+播放、2000+关注，这些数字让我感受到与观众的连接，也让我更珍惜每一次创作的机会。</p>
            
            <p>我的工作经历涵盖多个领域：我曾从事AI模型训练，帮助游戏原画工作提升80%以上的效率；参与过文创产品的设计与开发；目前，我在AI图像效果类海外产品和AI相机类型产品中担任核心效果实现成员，其中一款摄影类产品在巴西地区登上榜首，并在Google Play上实现了500万+下载。这些成果源于我和团队的努力，以及对细节的专注。</p>
            
            <p>在技术上，我熟悉ComfyUI工作流，掌握视觉图像模型、视频模型和大语言多模态模型，能够编写AI相关代码；我也有运营数据分析的经验，熟悉外网新闻动态，还曾搭建过模板电商平台。AIGC领域是我深耕的方向，我喜欢通过技术和创意解决问题，愿意在日常工作中不断学习和精进。</p>
            
            <p>热爱摄影、设计和AI的我，踏实工作、用心生活，希望能与志同道合的人一起，在技术的道路上稳步前行，创造有意义的价值。</p>
          </div>
          <div className="about-image">
            <img src="/images/about_me.png" alt="关于我" />
          </div>
        </div>
      </div>
      
      {/* 联系我区域 */}
      <ContactCTA />
    </div>
  );
};

export default About; 